import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { nWithCommas, addSuscribe, getData_menuExterior } from '../../utils';
import {
    setComposicion, okButton, setComposicionSaldoLiquido, recargaCartera,
    setSaldoTotal, setRendimientos, setTiposServicios
} from '../../redux/actions';
import 'chartjs-plugin-labels';
import { PIE_PLUGIN } from '../../properties';
import Reload from '../reload';
import firebase from 'firebase';
import M from 'materialize-css';
import _ from 'lodash';

const TXT = "La posición muestra precios de valuación al cierre del día hábil anterior, los saldos y la posición de la cartera pueden verse afectados por los movimientos y operaciones que se realicen en el transcurso del día.";

class PosicionCartera extends Component {

    state = {
        loading: true,
        posicionCartera: false,
        dataCake: false,
        contrato: false,
        dataUserConfig: false,
        esRecargaCartera: false,
        configLumina: false
    }


    getDateMenuExterior = async () => {
        const dataMenuE = await getData_menuExterior();
        const configLumina = dataMenuE
            && dataMenuE.configLumina.activo ? true : false;
        this.setState({ dataMenuExterior: dataMenuE, configLumina });

        return configLumina;
    }


    async componentDidUpdate(prevProps, prevState) {


        if (!_.isEqual(prevProps.posicionCartera, this.props.posicionCartera)) {
            if (this.props.posicionCartera) {
                this.getDataCake(this.props.posicionCartera);
            }
        }
    }

    async componentDidMount() {

        await this.getDateMenuExterior();

        // Lumina ya llega estructurada desde la cloud function (esLumina), igual que TAS
        if (this.props.posicionCartera) {
            this.getDataCake(this.props.posicionCartera);
        }

    }

    // async getSaldoTotal() {
    //     try {
    //         let saldoTotal = await getSaldoLiquido(this.props)
    //         this.props.setSaldoTotal(saldoTotal);
    //     } catch (error) {

    //     }

    // }

    getConfig = () => {
        try {

            let refSnap = firebase.firestore().doc(`/usuarios/${this.props.dataUser.IdUsuario}/configuraciones/usuario`).onSnapshot((snap) => {
                if (snap.exists) {
                    let dataUserConfig = snap.data();
                    this.setState({ dataUserConfig });
                } else {
                    this.setState({ dataUserConfig: { mostrar_saldo: true } });
                }
            })

            addSuscribe(refSnap);
        } catch (error) {

        }
    }
    getDataCake = (posicionCartera) => {
 
        console.log(posicionCartera);
        let labels = [];
        let data = [];
        let backgroundColor = [];
        if (posicionCartera.detalle && posicionCartera.detalle && posicionCartera.detalle.length) {

            //suma de porcentajes
            let sumaPorcentajes = 0;
            for (let porcentajes of posicionCartera.detalle) {
                let porcentaje = porcentajes[0] ? porcentajes[0].Porcentaje : 0;
                sumaPorcentajes += porcentaje;

            }

            if (!posicionCartera.esLumina) {
                if (sumaPorcentajes > 0) {
                    let index = 0;
                    for (let dPC of posicionCartera.detalle) {

                        let d = dPC[0];

                        if (d.DescRama.trim() === 'EFECTIVO' && d.detalle && d.detalle.length) {
                            this.props.setComposicionSaldoLiquido(d);
                        }

                        //if (d.MontoMdoMN > 0) {
                        let descRama = d.DescRama.trim() === 'EFECTIVO' ? 'SALDO LÍQUIDO' : d.DescRama.trim();
                        labels.push(descRama);

                        data.push(d.Porcentaje);
                        backgroundColor.push(this.getColorBG(d.DescRama.trim(), index, posicionCartera.esLumina));
                        index++;
                        //}
                    }
                } else {
                    labels.push('Cartera sin posición');
                    data.push(-100);
                    backgroundColor.push('#808080');
                }
            } else {
                //Saldo líquido (TOTAL DE LIQUIDEZ) va al inicio, conservando el color original de cada rama
                const esSaldoLiquidoLumina = dPC => dPC[0] && dPC[0].DescRama.trim().toUpperCase() === 'TOTAL DE LIQUIDEZ';
                posicionCartera.detalle.forEach((dPC, i) => {
                    if (dPC[0] && dPC[0].colorIndex === undefined) {
                        dPC[0].colorIndex = i;
                    }
                });
                posicionCartera = {
                    ...posicionCartera,
                    detalle: [...posicionCartera.detalle].sort((a, b) => esSaldoLiquidoLumina(b) - esSaldoLiquidoLumina(a))
                };

                let index = 0;
                for (let dPC of posicionCartera.detalle) {

                    let d = dPC[0];

                    if (d.DescRama.trim().toUpperCase() === 'TOTAL DE LIQUIDEZ' && d.detalle && d.detalle.length) {
                        this.props.setComposicionSaldoLiquido(d);
                    }

                    //if (d.MontoMdoMN > 0) {
                    let descRama = d.DescRama.trim().toUpperCase() === 'TOTAL DE LIQUIDEZ' ? 'SALDO LÍQUIDO' : d.DescRama.trim();
                    labels.push(descRama);

                    data.push(d.Porcentaje);
                    backgroundColor.push(this.getColorBG(d.DescRama.trim(), d.colorIndex !== undefined ? d.colorIndex : index, true));
                    index++;
                    //}
                }
            }




            let dataCake = {
                labels,
                datasets: [{
                    data, backgroundColor
                }]
            }

            this.setState({ dataCake, posicionCartera, loading: false }, () => {
                M.Tooltip.init(document.querySelectorAll('.tooltipped'), {});
                this.getConfig();
            });
        } else {
            this.setState({ dataCake: false, posicionCartera: posicionCartera || {}, loading: false }, () => {
                M.Tooltip.init(document.querySelectorAll('.tooltipped'), {});
                this.getConfig();
            });
        }
    }


    render() {
        let { posicionCartera, loading, dataCake, dataUserConfig } = this.state;
        return (
            <div className="row">

                <ul className="collection with-header posicionCartera z-depth-2">
                    <li className="collection-header">
                        {
                            loading ?
                                <div className="row">
                                    <div className="col s12 center-align">
                                        <Reload action={() => { }} />
                                    </div>
                                </div>
                                :

                                <div className="row">
                                    <div className="col s6">
                                        <p>Posición de cartera <i className="material-icons iconF cursorPointer tooltipped"
                                            data-position="bottom" data-tooltip={TXT}
                                        >help_outline</i></p>
                                        {
                                            dataUserConfig && dataUserConfig.mostrar_saldo && posicionCartera.totalCartera && posicionCartera.totalCartera.length
                                                && posicionCartera.totalCartera[0].MontoMdoMN
                                                ?
                                                <p className="boldText">${nWithCommas(parseFloat(posicionCartera.totalCartera[0].MontoMdoMN).toFixed(2).toString())}</p>
                                                : <p className="boldText">${nWithCommas(parseFloat(0).toFixed(2).toString())}</p>
                                        }

                                        <p>Composición</p>
                                    </div>
                                    <div className="col s6 right-align">
                                        <p>{this.props.dataUser.FechaSistema}</p>
                                    </div>
                                    <div className="col s12 center-align">
                                        {
                                            dataCake ?
                                                <Pie data={dataCake} options={PIE_PLUGIN}
                                                    width={200} height={100}
                                                />
                                                : null
                                        }

                                    </div>
                                </div>
                        }
                    </li>
                    {
                        posicionCartera.detalle && posicionCartera.detalle.length ?
                            posicionCartera.detalle.map((data, i) => {
                                let v = data[0];
                                if (v.MontoMdoMN !== 0) {


                                    return (
                                        <li className="collection-item hoverContent" key={i}>
                                            <div className="cursorPointer" onClick={() => {
                                                if (v.detalle && v.detalle.length) {
                                                    v.esSaldoProyectado = false;
                                                    if (posicionCartera.esLumina) {
                                                        v.esLumina = true;
                                                    }
                                                    console.log("Composicion seleccionada: ", v);
                                                    this.props.setComposicion(v);
                                                }
                                            }}>
                                                <div className="row noMBottom flex">
                                                    <div className="col s1">
                                                        <div className="colorIndicator" style={{ backgroundColor: this.getColorBG(v.DescRama, v.colorIndex !== undefined ? v.colorIndex : i, posicionCartera.esLumina) }}>

                                                        </div>
                                                    </div>
                                                    <div className="col s10">
                                                        <p className="noMargin txtCap">
                                                            {v.DescRama.trim() === "EFECTIVO" || v.DescRama.trim().toUpperCase() === "TOTAL DE LIQUIDEZ" ? 'Saldo líquido' : v.DescRama.trim().toLowerCase()}
                                                        </p>
                                                        {
                                                            dataUserConfig && dataUserConfig.mostrar_saldo ?
                                                                <p className="boldText">

                                                                    ${nWithCommas(parseFloat(v.MontoMdoMN).toFixed(2).toString())} ({parseFloat(v.Porcentaje || 0).toFixed(2)}%)

                                                                </p>
                                                                : null}
                                                    </div>
                                                    <div className="col s1 valign-wrapper">
                                                        <i className={v.detalle && v.detalle.length ? 'material-icons cursorPointer ' : 'material-icons cursorPointer white-text'}

                                                        >keyboard_arrow_right</i>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                }
                                return null;
                            })
                            : "Sin posición disponible."
                    }
                    <li className="collection-item">
                        <div className="row">
                            <div className="col s12 ft-12">
                                Recuerda que la información definitiva respecto a tu saldo es la que recibes a través de tu estado de cuenta.
                            </div>
                            <div className="col s12 ft-12 mt-1">
                                {TXT}
                            </div>
                        </div>
                    </li>
                </ul>

            </div>
        )
    }

    getColorBG = (DescRama, index = 0, esLumina = false) => {
   
        if (esLumina || this.state.configLumina) {
            const luminaColors = ['#36CCE6', '#A3E7D7', '#BFDD7E', '#B487B8', '#FFCD00', '#AAD5DA'];
            return luminaColors[index % luminaColors.length];
        }

        if (DescRama.trim().toLowerCase() === 'efectivo') {
            return '#12C3E2';
        }

        if (DescRama.trim() === 'INSTRUMENTOS DE DEUDA Y FONDOS DE INVERSIÓN DE DEUDA') {
            return '#6CDBC7';
        }

        if (DescRama.trim() === 'ACCIONES Y FONDOS DE INVERSIÓN DE RENTA VARIABLE') {
            return '#A6D043';
        }

        if (DescRama.trim() === 'INSTRUMENTOS EN OTRAS DIVISAS Y FONDOS DE INVERSIÓN DE DEUDA EN OTRAS DIVISAS') {
            return '#A25EB5';
        }

        if (DescRama.trim() === 'DERIVADOS') {
            return '#FFA400';
        }


    }
}

const mapStateToProps = state => {
    let { dataUser, currentContrato, menuPerfil, contratosUser,
        chequera, history, esRecargaCartera, saldoTotal, posicionCartera,
        composicion
    } = false;
    if (state.servicesActions) {
        dataUser = state.servicesActions.dataUser || false;
        currentContrato = state.servicesActions.currentContrato || false
        contratosUser = state.servicesActions.contratosUser || false
        chequera = state.servicesActions.chequera || false

    }

    if (state.commonsActions) {
        composicion = state.commonsActions.composicion || false;
        menuPerfil = state.commonsActions.menuPerfil || false;
        history = state.commonsActions.history || false;
        esRecargaCartera = state.commonsActions.esRecargaCartera || false;
        saldoTotal = state.commonsActions.saldoTotal || 0;
        posicionCartera = state.commonsActions.posicionCartera || false;
    }

    return {
        dataUser, currentContrato, menuPerfil, contratosUser, chequera, history,
        esRecargaCartera, saldoTotal, posicionCartera, composicion
    };
};
export default connect(mapStateToProps, {
    setComposicion, okButton, setComposicionSaldoLiquido,
    recargaCartera, setSaldoTotal, setRendimientos, setTiposServicios
})(PosicionCartera)